import { useEffect, useState } from 'react';
import { getAnalyticsConsent, initialiseAnalytics, setAnalyticsConsent } from '../lib/analytics';

export function CookieBanner() {
  const [consent, setConsent] = useState(getAnalyticsConsent());
  useEffect(() => { initialiseAnalytics(); }, []);
  if (consent) return null;
  const choose = (value: 'accepted' | 'declined') => { setAnalyticsConsent(value); setConsent(value); };
  return (
    <aside className="cookie-banner" aria-label="Cookie preferences">
      <div><strong>Your privacy matters.</strong><p>CoopCore uses essential cookies for site operation. Optional analytics cookies only load after you accept them.</p></div>
      <div className="cookie-actions"><button className="button button-secondary" onClick={() => choose('declined')}>Essential only</button><button className="button button-primary" onClick={() => choose('accepted')}>Accept analytics</button></div>
    </aside>
  );
}
